var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var TemplateListItem = /** @class */ (function () {
    function TemplateListItem(obj, id) {
        this.bg_name = '';
        this.en_name = '';
        this.bg_button_name = '';
        this.en_button_name = '';
        this.link = '';
        this.template = '';
        this.image = '';
        this.nameTemplate = '';
        if (id) {
            this.id = id;
        }
        this.bg_name = obj.bg_name;
        this.en_name = obj.en_name;
        this.bg_button_name = obj.bg_button_name;
        this.en_button_name = obj.en_button_name;
        this.link = obj.link;
        this.template = obj.template;
        if (obj.template === "alpha") {
            this.nameTemplate = "Шаблон 1";
        }
        else {
            this.nameTemplate = "Шаблон 2";
        }
        this.image = obj.image;
    }
    return TemplateListItem;
}());
export { TemplateListItem };
var Template = /** @class */ (function (_super) {
    __extends(Template, _super);
    function Template(obj, id) {
        return _super.call(this, obj, id) || this;
    }
    return Template;
}(TemplateListItem));
export { Template };
export function createTemplateListItem(obj, id) {
    return new TemplateListItem(obj, id);
}
export function createTemplate(obj, id) {
    return obj;
}
export function createTemplates(rawTemplates, id) {
    var templates = [];
    var rawTemplatesData = rawTemplates;
    for (var _i = 0, rawTemplatesData_1 = rawTemplatesData; _i < rawTemplatesData_1.length; _i++) {
        var rawTemplate = rawTemplatesData_1[_i];
        var template = createTemplateListItem(rawTemplate.attributes, rawTemplate.id);
        templates.push(template);
    }
    return templates;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/template/template.ts
// module id = 136
// module chunks = 0